<select class="form-control slFld" [id]="selFldHour" [name]="selFldHour" [disabled] = "childStatus" (change)=selVal(selFldHour,hourVal,minVal,secVal) [(ngModel)]="hourVal" >
	<option value="">Hour</option>
	<option *ngFor = "let hour of dayHour" value="{{hour}}">{{hour}}</option>
</select>
<select class="form-control slFld" [id]="selFldMin" [name]="selFldMin" [disabled] = "childStatus" [(ngModel)]="minVal" (change)=selVal(selFldHour,hourVal,minVal,secVal) >
	<option value="">Minutes</option>
	<option *ngFor = "let min of dayMin" value="{{min}}">{{min}}</option>
</select>
<select class="form-control slFld" [id]="selFldSec" [name]="selFldSec" [disabled] = "childStatus" [(ngModel)]="secVal" (change)=selVal(selFldHour,hourVal,minVal,secVal) >
	<option value="">Seconds</option>
	<option *ngFor = "let sec of daySec" value="{{sec}}">{{sec}}</option>
</select>